import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import Button from '@/components/Button'
import QuizCard from '@/components/Cards/QuizCard'
import Container from '@/components/Container'
import Section from '@/components/Section'
import Title from '@/components/Title'
import React from 'react'
import style from '../styles/quizzes.module.scss'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import { api } from '@/api'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'

const Quizzes = (): React.ReactElement => {
  return (
    <Section>
      <FetcherList
        initFilter={{ page_size: 4 }}
        isScrollTop={false}
        isHistoryPush={false}
        api={api.getQuizList}
      >
        {({
          results,
          status,
          showMore,
          isNext
        }: IFetcherListResults<any[]>) => {
          return (
            <Container>
              <Title type='h2' theme='h1' className={style.quiz__title}>
                Викторины
              </Title>

              {results?.length > 0
                ? (
                  <div className={style.quiz__cards}>
                    {results.map((el) => {
                      return (
                        <QuizCard
                          key={el.id}
                          id={el.id}
                          image={el.preview_picture?.[0] ?? ''}
                          title={el.name}
                          text={el.preview_text}
                        />
                      )
                    })}
                  </div>
                  )
                : null}

              {status === dataStates.loading
                ? (
                  <div className={style.quiz__cards}>
                    <PlaceholderLoading
                      shape='rect'
                      width='100%'
                      height='233px'
                    />
                    <PlaceholderLoading
                      shape='rect'
                      width='100%'
                      height='233px'
                    />
                  </div>
                  )
                : null}

              {isNext
                ? (
                  <Button
                    disabled={status === dataStates.loading}
                    size='large'
                    wide
                    outline
                    className={style.quiz__more}
                    onClick={showMore}
                  >
                    Еще викторины
                  </Button>
                  )
                : null}
            </Container>
          )
        }}
      </FetcherList>
    </Section>
  )
}

export default Quizzes
